import {
  ReferralChannelsActionTypes,
  ReferralChannelParams,
  CHANNELS
} from 'types';
import { all, takeLatest, call, put, select } from 'redux-saga/effects';
import Services from '../../services';
import { initAppFailure } from 'redux/app/actions';
import util from 'utilities/helper.util';
import errorJson from 'locales/en.json';

import {
  activateReferralChannelsSuccess,
  activateReferralChannelsFailure,
  fetchReferralChannelsFailure,
  fetchReferralChannelsSuccess,
  draftReferralChannelsSuccess,
  draftReferralChannelsFailure,
  fetchGmlProjectionFailure,
  fetchGmlProjectionSuccess,
  // fetchActiveChannelByIdStart,
  fetchActiveChannelByIdSuccess,
  fetchActiveChannelByIdFaiure,
  fetchReferralChannelsStart
} from './actions';

export function* doFetchReferralChannels(req: any) {
  const organisationId: ReferralChannelParams = req.payload;
  const getSession = (state: any) => state.session;
  const session = yield select(getSession);
  if (session.isAuthenticated) {
    try {
      const resActiveChannel: any = yield call(
        Services.channels.fetchActiveChannelsSevice,
        organisationId
      );
      const resDraftChannel: any = yield call(
        Services.channels.fetchDraftChannelsService,
        organisationId
      );
      try {
        yield put(
          fetchReferralChannelsSuccess({
            activeChannel: resActiveChannel?.ReferralConfigurationChannels[0],
            draftChannel: resDraftChannel?.ReferralConfigurationChannels[0]
          })
        );
      } catch (error) {
        const errorMsg = error.message ? error.message : error;
        yield put(fetchReferralChannelsFailure(errorMsg));
        yield put(initAppFailure());
      }
    } catch (error) {
      const errorMsg = error.message ? error.message : error;
      yield put(fetchReferralChannelsFailure(errorMsg));
      yield put(initAppFailure());
    }
  }
}

export function* doDraftReferralChannels(req: any) {
  const { organisationId, requestBody }: ReferralChannelParams = req.payload;
  const getSession = (state: any) => state.session;
  const session = yield select(getSession);
  if (session.isAuthenticated) {
    try {
      const res: any = yield call(Services.channels.addNewReferralChannel, {
        organisationId,
        requestBody
      });

      if (!res?.error) {
        const isSWXAutomateRes: boolean =
          res === null &&
          requestBody?.configurationType === CHANNELS.SWX_AUTOMATE;
        const response = isSWXAutomateRes ? { swxAutomateVerified: true } : res;
        yield put(draftReferralChannelsSuccess(response));
      } else {
        yield put(draftReferralChannelsFailure(res.error.message));
        yield put(initAppFailure());
      }
    } catch (error) {
      const errorMsg = error.message ? error.message : error;
      yield put(draftReferralChannelsFailure(errorMsg));
      yield put(initAppFailure());
    }
  }
}

export function* doUpdateReferralChannels(req: any) {
  const {
    organisationId,
    channelId,
    requestBody
  }: ReferralChannelParams = req.payload;

  const getSession = (state: any) => state.session;
  const referralChannels = (state: any) => state.referralChannels;
  const session = yield select(getSession);
  const state = yield select(referralChannels);

  if (session.isAuthenticated) {
    try {
      const res = yield call(Services.channels.updatedReferralChannel, {
        organisationId,
        channelId,
        requestBody
      });
      if (!res.error) {
        let responseBody = {};
        if (res.status === 'LIVE') {
          responseBody = {
            loading: false,
            activeChannel: { ...res }
          };
        } else {
          responseBody = {
            activeChannel: state.activeChannel,
            draftChannel: {
              ...res,
              gmlProjection:
                res.LegacyEmailConfiguration?.gmlProjection ||
                res.WebhookConfiguration?.gmlProjection,
              submitting: false
            }
          };
        }
        yield put(activateReferralChannelsSuccess(responseBody));
        yield put(fetchReferralChannelsStart(req.payload.organisationId));
      } else {
        yield put(activateReferralChannelsFailure(res.error.message));
      }
    } catch (error) {
      const errorMsg = error.message ? error.message : error;
      yield put(activateReferralChannelsFailure(errorMsg));
      yield put(initAppFailure());
    }
  }
}

export function* doFetchGmlProjection() {
  const getSession = (state: any) => state.session;
  const session = yield select(getSession);
  if (session.isAuthenticated) {
    try {
      let res = yield call(Services.channels.fetchGMLProjection);
      res = [{ code: null, label: '-' }, ...res];

      if (!res.error) {
        yield put(fetchGmlProjectionSuccess(res));
      } else {
        yield put(fetchGmlProjectionFailure(res.error.message));
        yield put(initAppFailure());
      }
    } catch (error) {
      const errorMsg = error.message ? error.message : error;
      yield put(fetchGmlProjectionFailure(errorMsg));
      yield put(initAppFailure());
    }
  }
}

export function* onFetchReferralChannels() {
  yield takeLatest(
    ReferralChannelsActionTypes.FETCH_REFERRAL_CHANNELS_START,
    doFetchReferralChannels
  );
}

export function* onDraftReferralChannels() {
  yield takeLatest(
    ReferralChannelsActionTypes.DRAFT_REFERRAL_CHANNELS_START,
    doDraftReferralChannels
  );
}

export function* onUpdateReferralChannels() {
  yield takeLatest(
    ReferralChannelsActionTypes.UPDATE_REFERRAL_CHANNELS_START,
    doUpdateReferralChannels
  );
}

export function* onFetchGmlProjection() {
  yield takeLatest(
    ReferralChannelsActionTypes.FETCH_GML_PROJECTION_START,
    doFetchGmlProjection
  );
}

export function* dofetchActiveChannelByIdStart(request: any) {
  try {
    const response = yield call(
      Services.channels.fetchActiveChannelById,
      request.payload.organisationId,
      request.payload.channelId
    );
    if (response.error) {
      const localisedErrorMsg = util.optimizeErrMsg(
        errorJson.common.errors,
        'common.errors',
        response.error.message
      );
      yield put(fetchActiveChannelByIdFaiure(localisedErrorMsg));
    } else {
      yield put(fetchActiveChannelByIdSuccess(response));
    }
  } catch (error) {
    const localisedErrorMsg = util.optimizeErrMsg(
      errorJson.common.errors,
      'common.errors',
      error
    );
    yield put(fetchActiveChannelByIdFaiure(localisedErrorMsg));
  }
}

export function* onfetchActiveChannelByIdStart() {
  yield takeLatest(
    ReferralChannelsActionTypes.FETCH_ACTIVE_CHANNEL_START,
    dofetchActiveChannelByIdStart
  );
}
export function* referralChannelsSagas() {
  yield all([
    call(onFetchGmlProjection),
    call(onFetchReferralChannels),
    call(onDraftReferralChannels),
    call(onUpdateReferralChannels),
    call(onfetchActiveChannelByIdStart)
  ]);
}

export default referralChannelsSagas;
